<template>
    <a
        :style="borderStyle"
        class="AmbassadorshipCard flex border list-group-item bg-white p-4 text-black m-b-lg items-center flex-col sm:flex-row"
    >
        <div class="w-full p-l-xs sm:p-l-lg text-gray-900">
            <div class="flex items-center flex-row">
                <div class="flex items-center flex-col lg:flex-row w-full">
                    <div class="flex items-center w-full lg:w-1/4 pr-2">
                        <img
                            :src="displayAvatar"
                            :alt="displayName"
                            class="spark-profile-photo-lg m-r-lg"
                        />
                        <h5 class="font-semibold m-0 leading-normal" v-text="displayName" />
                    </div>
                    <ContentInsights
                        class="m-t-lg w-full lg:w-3/4"
                        :columns="{ default: 2, xs: 2, sm: 5, md: 5, xl: 5 }"
                        :rows="1"
                        :gap="{ default: '10px', sm: '15px' }"
                        :model="ambassadorship"
                    >
                        <template v-slot:default="{ metric }">
                            <h5 class="text-xs mb-1">{{ metric.name }}</h5>
                            <span class="text-xl"
                                >{{ Number(metric.value).toLocaleString() }}
                            </span>
                        </template>
                    </ContentInsights>
                </div>
                <div v-if="clickable" class="p-r-lg p-md sm:p-xs ">
                    <i class="fa fa-chevron-right"></i>
                </div>
            </div>
            <TeaseItems :items="contents" :limit="currentLimit" :teaser-slot-size="0">
                <template v-slot:default="{ displayItems, moreItems, showMore }">
                    <div
                        class="border-gray-300 border-t mt-4 pt-4 bg-gray-100 -m-4 -ml-5 p-4 rounded-b-lg"
                    >
                        <ResponsiveGrid
                            v-if="displayItems.length > 0"
                            :columns="{ default: 3, sm: 6, lg: 10 }"
                            :rows="1"
                            :gap="{ default: '10px', sm: '15px' }"
                            @preparedCells="limit = $event"
                        >
                            <div
                                v-for="(content, index) of displayItems"
                                :key="content.id"
                                class="mb-4"
                            >
                                <ContentMedia
                                    v-bind="{ content }"
                                    class="bg-center rounded"
                                    style="padding-top: 170%"
                                >
                                    <div
                                        v-if="index === Object.keys(contents).length - 1"
                                        class="min-h-full min-w-full absolute top-0 flex items-center justify-center rounded background-primary"
                                    >
                                        <i class="fa fa-plus text-white"></i>
                                    </div>
                                </ContentMedia>
                            </div>
                        </ResponsiveGrid>
                        <div>
                            <p v-if="displayItems.length === 0" class="text-sm mb-0">
                                Ingen opslag at vise. <br />
                            </p>
                            <p class="text-sm mb-0">
                                <slot name="footer"></slot>
                            </p>
                        </div>
                    </div>
                </template>
            </TeaseItems>
        </div>
    </a>
</template>

<style lang="less" type="text/less">
.AmbassadorshipCard {
    border-left-width: 6px !important;
    border-radius: 15px !important;
}

.AmbassadorshipCard .background-primary {
    background-color: #a05dcd94;
}
</style>

<script type="text/babel">
import ContentInsights from 'dashboard-js/components/contents/ContentInsights'
import ContentMedia from 'dashboard-js/components/influencers/ContentMedia'
import ResponsiveGrid from 'dashboard-js/components/ResponsiveGrid'
import TeaseItems from 'dashboard-js/components/TeaseItems'

export default {
    components: { ResponsiveGrid, ContentInsights, ContentMedia, TeaseItems },

    props: ['ambassadorship', 'displayAvatar', 'displayName', 'clickable'],

    data() {
        return {
            contents: this.ambassadorship.contents,
            limit: null,
        }
    },

    computed: {
        currentLimit() {
            return this.limit !== null ? this.limit : 1000
        },
        borderStyle() {
            return this.ambassadorship.status === 'active'
                ? { 'border-left-color': '#9ccc65' }
                : { 'border-left-color': '#718096' }
        },
    },
}
</script>
